(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["estoria-comment-controls"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('estoria-review-summary')) {
    customElements.define('estoria-review-summary', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.ownerDocument.addEventListener('shopify:section:load', () => this.refresh(), options);
        this.ownerDocument.addEventListener('shopify:section:unload', event => {
          if (this.source && event.target?.contains(this.source)) {
            this.hidden = true;
            this.source = null;
          }
        }, options);
        this.refresh();
      }

      refresh() {
        const main = this.ownerDocument.querySelector('product-info[data-update-url="true"]');
        this.source = main?.querySelector('.estoria-published-rating');
        const rating = this.source?.querySelector('strong')?.textContent.trim();
        const count = this.source?.querySelector('.estoria-published-rating__count')?.textContent.trim();
        const stars = this.source?.querySelector('.estoria-published-rating__stars');
        this.hidden = !rating || !count || !stars;
        if (this.hidden) return;
        this.querySelector('[data-summary-rating]').textContent = rating;
        this.querySelector('[data-summary-count]').textContent = count;
        this.querySelector('[data-summary-stars]').setAttribute('aria-label', stars.getAttribute('aria-label') || '');
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["estoria-hero-wave"] && !Shopify.designMode) return;
  try {
    
  class EstoriaHero extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.videos = [...this.querySelectorAll('video')];
      this.button = this.querySelector('[data-video-toggle]');
      if (!this.videos.length) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.userPaused = false;
      this.inView = !('IntersectionObserver' in window);

      this.motionQuery.addEventListener('change', () => this.updateMedia(), options);
      this.mobileQuery.addEventListener('change', () => this.updateMedia(), options);
      this.ownerDocument.addEventListener('visibilitychange', () => this.updateMedia(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.updateMedia();
        });
        this.observer.observe(this);
      }
      this.button?.addEventListener('click', () => {
        if (!this.activeVideo) return;
        this.userPaused = !this.activeVideo.paused;
        this.updateMedia();
      }, options);

      this.videos.forEach((video) => {
        ['loadeddata', 'playing', 'pause', 'error'].forEach((event) => {
          video.addEventListener(event, () => this.updateControl(), options);
        });
      });

      this.updateMedia();
    }

    updateMedia() {
      const desktop = this.querySelector('video.estoria-hero-wave__media-element--desktop');
      const mobile = this.querySelector('video.estoria-hero-wave__media-element--mobile');
      this.activeVideo = this.motionQuery.matches ? null : (this.mobileQuery.matches && mobile ? mobile : desktop);
      const shouldPlay = this.inView && !this.ownerDocument.hidden && !this.userPaused;

      this.videos.forEach((video) => {
        if (video !== this.activeVideo || !shouldPlay || video.error) video.pause();
      });
      if (this.activeVideo && shouldPlay && !this.activeVideo.error) {
        this.activeVideo.play().catch(() => this.updateControl());
      }
      this.updateControl();
    }

    updateControl() {
      this.videos.forEach((video) => {
        if (video.readyState >= 2 && !video.error) video.dataset.ready = 'true';
        else delete video.dataset.ready;
      });

      if (!this.button) return;
      this.button.hidden = !this.activeVideo || this.motionQuery.matches || Boolean(this.activeVideo.error);
      if (this.button.hidden) return;
      const paused = this.activeVideo.paused;
      const label = paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      this.button.setAttribute('aria-label', label);
      this.button.setAttribute('title', label);
      this.button.querySelector('[data-play-icon]').hidden = !paused;
      this.button.querySelector('[data-pause-icon]').hidden = paused;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.videos?.forEach((video) => video.pause());
    }
  }

  if (!customElements.get('estoria-hero')) customElements.define('estoria-hero', EstoriaHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["estoria-real-life"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('estoria-reels')) {
    customElements.define('estoria-reels', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.abort = new AbortController();
        this.videos = Array.from(this.querySelectorAll('video'));
        this.visible = new Map();
        this.userPaused ??= new WeakSet();
        this.stopping ??= new WeakSet();
        this.autoplaying ??= new WeakSet();
        this.pendingPlay = new WeakSet();
        this.carouselLoading = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abort.signal };
        this.inView = !('IntersectionObserver' in window);
        this.hovered = false;
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovered = true; this.syncCarouselMotion(); }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.syncCarouselMotion(); }, options);
        this.addEventListener('focusin', () => this.syncCarouselMotion(), options);
        this.addEventListener('focusout', () => queueMicrotask(() => this.syncCarouselMotion()), options);
        this.querySelectorAll('.estoria-reels__navigation button').forEach(button => {
          button.addEventListener('click', () => this.moveVideo(button.name), options);
        });
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.estoria-reels__item');
          const track = this.querySelector('.estoria-reels__track');
          const index = Array.from(track?.children || []).indexOf(item);
          if (index >= 0) this.carousel?.scrollTo(index, true);
        }, options);
        this.videos.forEach(video => {
          video.addEventListener('pointerdown', () => this.hydrateVideo(video), options);
          video.addEventListener('keydown', event => { if (event.key === ' ' || event.key === 'Enter') this.hydrateVideo(video); }, options);
          video.addEventListener('loadeddata', () => this.sync(), options);
          video.addEventListener('pause', () => {
            if (this.stopping.has(video)) this.stopping.delete(video);
            else {
              this.userPaused.add(video);
              this.autoplaying.delete(video);
            }
          }, options);
          video.addEventListener('play', () => {
            this.userPaused.delete(video);
            if (this.ownerDocument.hidden || (this.observer && !this.visible.get(video))) this.stop(video);
          }, options);
        });
        this.ownerDocument.addEventListener('visibilitychange', () => this.sync(), options);
        this.reducedMotion.addEventListener('change', () => this.sync(), options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => this.visible.set(entry.target, entry.isIntersecting && entry.intersectionRatio >= .25));
            this.sync();
          }, { threshold: [0, .25] });
          this.videos.forEach(video => this.observer.observe(video));
          this.loadObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.hydrateVideo(entry.target);
              this.loadObserver.unobserve(entry.target);
            });
          }, { rootMargin: '250px 0px', threshold: 0 });
          this.videos.forEach(video => this.loadObserver.observe(video));
          this.carouselObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.carouselObserver.disconnect();
            if (this.dataset.carouselUrl) this.loadCarousel(this.abort.signal);
          }, { rootMargin: '250px 0px', threshold: 0 });
          this.carouselObserver.observe(this);
          this.reelObserver = new IntersectionObserver(entries => {
            this.inView = entries.some(entry => entry.isIntersecting);
            this.syncCarouselMotion();
          });
          this.reelObserver.observe(this);
        }
        this.previewFrame = requestAnimationFrame(() => this.previewNeighbors());
        // Older browsers keep the native horizontal scroller and load videos on interaction.
      }
      hydrateVideo(video) {
        if (video.dataset.venoraLoaded === 'true') return;
        let assigned = false;
        if (video.dataset.src) { video.src = video.dataset.src; video.removeAttribute('data-src'); assigned = true; }
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          assigned = true;
        });
        if (assigned) { video.dataset.venoraLoaded = 'true'; video.preload = 'metadata'; video.load(); }
      }
      async loadCarousel(signal) {
        if (this.carousel || this.carouselLoading) return;
        this.carouselLoading = true;
        try {
          const { default: createCarousel } = await import(this.dataset.carouselUrl);
          if (!signal.aborted && signal === this.abort.signal) this.mountCarousel(createCarousel);
        } catch {
          this.dataset.carouselReady = 'false';
        } finally {
          if (!signal.aborted && signal === this.abort.signal) this.carouselLoading = false;
        }
      }
      mountCarousel(createCarousel) {
        const viewport = this.querySelector('.estoria-reels__viewport');
        const track = this.querySelector('.estoria-reels__track');
        if (!viewport || !track || track.children.length < 2 || this.carousel) return;
        cancelAnimationFrame(this.previewFrame);
        const [first, second] = track.children;
        const step = second.offsetLeft - first.offsetLeft;
        const fullWidth = !!this.querySelector('.estoria-reels__full-width');
        const initial = fullWidth && step > 0 ? Math.ceil((track.clientWidth - first.clientWidth) / (2 * step)) : 0;
        const centerOffset = fullWidth ? (track.clientWidth - first.clientWidth) / 2 : 0;
        const current = track.scrollLeft > 0 && step > 0 ? Math.round((track.scrollLeft + centerOffset - first.offsetLeft) / step) : initial;
        const startIndex = Math.min(Math.max(this.savedIndex ?? current, 0), track.children.length - 1);
        viewport.classList.add('is-carousel');
        track.scrollLeft = 0;
        try {
          this.carousel = createCarousel(viewport, {
            loop: this.dataset.autoScroll === 'true' || this.dataset.loop === 'true',
            align: fullWidth ? 'center' : 'start',
            startIndex,
            duration: 25,
            breakpoints: { '(prefers-reduced-motion: reduce)': { duration: 0 } },
          }, this.dataset.autoScroll === 'true');
        } catch (error) {
          viewport.classList.remove('is-carousel');
          throw error;
        }
        const updateNavigation = () => {
          this.querySelectorAll('.estoria-reels__navigation button').forEach(button => {
            button.disabled = button.name === 'next' ? !this.carousel.canScrollNext() : !this.carousel.canScrollPrev();
          });
        };
        this.carousel.on('select', updateNavigation).on('reInit', updateNavigation);
        this.carousel.on('reInit', () => this.syncCarouselMotion());
        this.carousel.on('autoScroll:play', () => queueMicrotask(() => this.syncCarouselMotion()));
        updateNavigation();
        this.dataset.carouselReady = 'true';
        this.syncCarouselMotion();
      }
      syncCarouselMotion() {
        const motion = this.carousel?.plugins?.().autoScroll;
        if (!motion) return;
        if (!this.inView || this.ownerDocument.hidden || this.reducedMotion.matches || this.hovered || this.matches(':focus-within') || this.dataset.designMode === 'true') motion.stop();
        else if (!motion.isPlaying()) motion.play();
      }
      moveVideo(direction) {
        if (this.carousel) {
          if (direction === 'next') this.carousel.scrollNext(this.reducedMotion.matches);
          else this.carousel.scrollPrev(this.reducedMotion.matches);
          return;
        }
        const track = this.querySelector('.estoria-reels__track');
        if (!track || track.children.length < 2) return;
        const step = track.children[1].offsetLeft - track.children[0].offsetLeft;
        const end = track.scrollWidth - track.clientWidth;
        let left = track.scrollLeft + (direction === 'next' ? step : -step);
        if (this.dataset.loop === 'true') {
          if (direction === 'next' && track.scrollLeft >= end - 1) left = 0;
          if (direction === 'previous' && track.scrollLeft <= 1) left = end;
        }
        track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }
      previewNeighbors() {
        const track = this.querySelector('.estoria-reels__full-width .estoria-reels__track');
        if (!track || track.scrollLeft > 0 || track.scrollWidth <= track.clientWidth) return;
        const [first, second] = track.children;
        if (!second || !first.clientWidth || !track.clientWidth) return;
        const step = second.offsetLeft - first.offsetLeft;
        if (step <= 0) return;
        const index = Math.ceil((track.clientWidth - first.clientWidth) / (2 * step));
        const card = track.children[Math.min(Math.max(index, 1), track.children.length - 1)];
        track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.clientWidth) / 2, behavior: 'instant' });
      }
      stop(video) {
        if (video.paused) return;
        this.autoplaying.delete(video);
        this.stopping.add(video);
        video.pause();
      }
      sync() {
        this.syncCarouselMotion();
        this.videos.forEach(video => {
          if ((this.observer && !this.visible.get(video)) || this.ownerDocument.hidden) {
            this.stop(video);
          } else if (this.dataset.autoplay === 'true' && !this.reducedMotion.matches && !navigator.connection?.saveData && !this.userPaused.has(video) && this.visible.get(video) && video.paused && !this.pendingPlay.has(video)) {
            this.hydrateVideo(video);
            this.autoplaying.add(video);
            this.pendingPlay.add(video);
            Promise.resolve(video.play()).catch(() => this.autoplaying.delete(video)).finally(() => this.pendingPlay.delete(video));
          } else if ((this.reducedMotion.matches || navigator.connection?.saveData || this.dataset.autoplay !== 'true') && this.autoplaying.has(video)) {
            this.stop(video);
          }
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.previewFrame);
        if (this.carousel) this.savedIndex = this.carousel.selectedScrollSnap();
        this.carousel?.destroy();
        this.carousel = null;
        this.querySelector('.estoria-reels__viewport')?.classList.remove('is-carousel');
        this.observer?.disconnect();
        this.loadObserver?.disconnect();
        this.carouselObserver?.disconnect();
        this.reelObserver?.disconnect();
        this.abort?.abort();
        this.videos?.forEach(video => this.stop(video));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
      this.resizeObserver.observe(this.header);

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  class StaticHeader extends HTMLElement {
    connectedCallback() {
      this.resizeObserver = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
